import { Flex } from '@chakra-ui/react';
import { ParagraphFormular } from '../../../generated/types';
import Container from '../../Layout/Container';
import Wrapper from '../Wrapper';
import React from 'react';
import FORMULAR_MAPPING from '../../../config/formular-mapping';

interface FormularProps {
    label?: string;
    subLabel?: string;
    data: ParagraphFormular;
}

const Formular: React.FC<FormularProps> = ({
    data,
}) => {
    let Form = FORMULAR_MAPPING[data.formular] || null;

    return (
        <Wrapper className="ParagraphFormulars">
            <Container>
                {Form && <Form data={data} />}
            </Container>
        </Wrapper>
    );
};

export default Formular;
